<template>
  <section id="all-email-logs" class="all-cases-view" v-loading="loading">
    <div class="container-small-table">
      <div class="listings-navbar">
        <el-row>
          <el-col :lg="24">
            <ul
              class="d-flex flex-wrap justify-content-end list-items-group-15"
            >
              <li>
                <div class="form-element search-with-filter-input">
                  <el-select
                    v-model="searchCaseId"
                    filterable
                    remote
                    :remote-method="querySpuAttrNames"
                    default-first-option
                    :loading="searchCaseLoading"
                    clearable
                    @change="getAuditlogsByCase"
                    @clear="clearAuditLogsSearch"
                  >
                    <el-option
                      v-for="(caseData, index) of allCases"
                      :key="index"
                      :label="caseData.accession_id"
                      :value="caseData._id"
                    ></el-option>
                  </el-select>
                  <span class="search-icon">
                    <img
                      src="@/assets/images/icons/search-icon-with-bg-red.svg"
                      alt="icon"
                      class="img-fluid"
                    />
                  </span>
                </div>
              </li>
            </ul>
          </el-col>
        </el-row>
      </div>

      <div class="primary-content-view-new">
        <div
          class="listings listings__table listings__all-cases"
          id="all-cases-listings"
        >
          <el-table
            :data="getAllEmailLogs.data"
            height="calc(100vh - 200px)"
            @sort-change="onChangeSort"
            :default-sort="{
              prop: orderBy,
              order: orderType == 'asc' ? 'ascending' : 'descending',
            }"
          >
            <el-table-column label="TO MAILS" prop="to_mail" min-width="280">
              <template #default="scope">
                <div v-if="scope.row.to_mail && scope.row.to_mail.length > 1">
                  <el-dropdown>
                    <span>
                      {{ scope.row.to_mail[0] }}

                      <img
                        src="@/assets/images/case-type-arrow.svg"
                        alt="icon"
                      />
                    </span>

                    <template #dropdown>
                      <el-dropdown-menu class="case-type-dropdown">
                        <el-dropdown-item
                          class="cases-view"
                          v-for="(mailData, index) of scope.row.to_mail"
                          :key="index"
                        >
                          {{ mailData }}
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </template>
                  </el-dropdown>
                </div>
                <div v-else class="case-type">
                  <span class="case-data-type width-270">
                    {{ scope.row.to_mail[0] }}
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="ACCESSION ID"
              min-width="160"
              prop="case_id.accession_id"
              ><template v-slot="scope">{{
                (scope.row.case_id && scope.row.case_id.accession_id) || "--"
              }}</template>
            </el-table-column>
            <el-table-column
              label="DESCRIPTION"
              sortable="custom"
              min-width="320"
              prop="description"
            >
              <template v-slot="scope">
                <span class="error-break">
                  {{ scope.row.description }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="user" label="User" min-width="180">
              <template v-slot="scope">
                <div v-if="scope.row.user_id">
                  {{ scope.row.user_id.first_name }}
                  {{ scope.row.user_id.last_name }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Created On"
              prop="created_at"
              sortable="custom"
              min-width="130"
            >
              <template #default="scope">
                <div v-if="scope.row.created_at" class="d-flex">
                  <div class="date pr-10">
                    {{ momentWithTimezone(scope.row.created_at, "MM-DD-yyyy") }}
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="listings listings__pagination">
        <el-pagination
          v-model:currentPage="page"
          v-model:page-size="pageSize"
          :page-sizes="[25, 50, 75, 100]"
          layout=" prev, pager, next, jumper, sizes ,total"
          :total="getAllEmailLogs.total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import FilterHelper from "@/mixins/FilterHelper";
import caseConstants from "@/config/constants/caseConstants";
export default {
  components: {},
  computed: {
    ...mapGetters("emailLogs", ["getAllEmailLogs"]),
    ...mapGetters("cases", ["getAllCases"]),
  },
  mounted() {
    this.setQueryParamsData();
    this.fetchAllLogs();
  },
  data() {
    return {
      search_string: "",
      page: 1,
      pageSize: 25,
      orderBy: "",
      orderType: "",
      loading: false,
      logsTable: {},
      searchCaseLoading: false,
      allCases: [],
      searchCaseId: "",
    };
  },

  mixins: [UserPermissionsHelper, FilterHelper],

  methods: {
    onChangeSort({ order, prop }) {
      if (order && prop) {
        this.orderBy = prop;
        this.orderType = order == "ascending" ? "asc" : "desc";
      } else {
        this.orderBy = "created_at";
        this.orderType = "DESC";
      }
      this.fetchAllLogs();
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.page = 1;

      this.fetchAllLogs();
    },
    handleCurrentChange(page) {
      this.page = page;

      this.fetchAllLogs();
    },
    prepareParams() {
      const params = {
        page: this.page,
        limit: this.pageSize,
      };
      if (this.search_string) {
        params.search_string = this.search_string;
      }
      if (this.orderBy && this.orderType) {
        params.order_by = this.orderBy.toLowerCase();
        params.order_type = this.orderType;
      }

      if (this.searchCaseId) {
        params.case_id = this.searchCaseId;
      }

      return params;
    },

    setQueryParamsData() {
      this.page = this.$route.query.selectedPage
        ? parseInt(this.$route.query.selectedPage)
        : 1;
      this.pageSize = this.$route.query.selectedPageSize
        ? parseInt(this.$route.query.selectedPageSize)
        : 25;
      if (this.$route.query.selectedString) {
        this.search_string = this.$route.query.selectedString;
      }
      if (this.$route.query.selectedOrderBy) {
        this.orderBy = this.$route.query.selectedOrderBy;
      }
      if (this.$route.query.selectedOrderType) {
        this.orderType = this.$route.query.selectedOrderType;
      }
      if (this.$route.query.selectedCaseId) {
        this.selectedCaseId = this.$route.query.selectedCaseId;
      }
    },
    updateQueryParams(params) {
      let selectedParams = {
        selectedPage: params.page,
        selectedString: params.search_string,
        selectedPageSize: params.limit,
        selectedOrderBy: params.order_by,
        selectedOrderType: params.order_type,
        selectedCaseId: this.$route.query.selectedCaseId,
        selectedSearchBy: this.searchBy || undefined,
      };
      this.updateQueryParam(this.$route.name, selectedParams);
    },
    async fetchAllLogs() {
      try {
        this.loading = true;
        let params = this.prepareParams();
        await this.$store.dispatch("emailLogs/fetchAllEmailLogs", params);
        this.updateQueryParams(params);
        this.logsTable = JSON.parse(JSON.stringify(this.getAllEmailLogs));
        this.loading = false;
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },

    async querySpuAttrNames(query) {
      if (query.length >= 3) {
        this.searchCaseLoading = true;
        let params = {
          search_string: query,
          get_all: true,
          status: caseConstants.CASE_STATUSES,
        };
        await this.$store.dispatch("cases/fetchAllCases", params);
        this.allCases = this.getAllCases.data;
        this.searchCaseLoading = false;
      }
    },
    async getAutoCompleteCasesData() {
      // to eleminate empty search strings

      this.previousSearchString = this.search_string;

      await this.fetchAllLogs(1);
    },

    getAuditlogsByCase() {
      this.getAutoCompleteCasesData();
    },
    async clearAuditLogsSearch() {
      this.searchCaseId = "";
      await this.fetchAllLogs(1);
    },
  },
  watch: {
    selectedCaseIds() {},
  },
};
</script>

<style lang="scss">
#all-email-logs {
  .listings__table .el-table table tbody tr td.el-table__cell {
    padding: 2.7px;
  }
}
</style>
<style lang="scss"></style>
